import APP from './app'

// Axios Settings
// ---------------------------------------------
import axios from 'axios'
axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest'
}

// Document Ready
// ---------------------------------------------
document.addEventListener('DOMContentLoaded', (event) => {
  APP.boot(document, window)
})
